import { Injectable } from '@angular/core';
import { ApplicationInsightsService } from './application-insights.service';

@Injectable({ providedIn: 'root' })
export class LoggingService {

  constructor(private aiService: ApplicationInsightsService) {}

  private get appInsights() {
    return this.aiService?.instance;
  }

  logEvent(name: string, properties?: any) {
    try {
      this.appInsights?.trackEvent({ name }, properties);
    } catch (e) {
      console.error('logEvent failed', e);
    }
  }

  logTrace(message: string, properties?: any) {
    try {
      this.appInsights?.trackTrace({ message }, properties);
    } catch (e) {
      console.error('logTrace failed', e);
    }
  }

  logException(error: any) {
    try {
      this.appInsights?.trackException({ exception: error });
    } catch (e) {
      console.error('logException failed', e, 'original:', error);
    }
  }

  setUser(userId: string) {
    try {
      this.appInsights?.setAuthenticatedUserContext(userId);
    } catch (e) {
      console.error('setUser failed', e);
    }
  }

  clearUser() {
    try {
      this.appInsights?.clearAuthenticatedUserContext();
    } catch (e) {
      console.error('clearUser failed', e);
    }
  }
}
